import logo from "./logo.png";

function App() {
  return (
    <main className="min-h-screen bg-background flex flex-col items-center px-6 md:px-12 lg:px-24 py-12 md:py-16 overflow-auto">
      {/* Logo */}
      <div className="mb-10 md:mb-12 opacity-0 animate-fade-in">
        <img
          src={logo}
          className="w-20 md:w-24 lg:w-48 text-foreground opacity-80"
          alt="logo"
        />
      </div>

      {/* Content */}
      <div className="max-w-3xl w-full text-center">
        {/* Title */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight mb-3 text-foreground opacity-0 animate-fade-in-up animation-delay-100">
          Vakra
        </h1>

        <p className="text-body text-base md:text-lg mb-12 md:mb-16 font-light tracking-wide opacity-0 animate-fade-in-up animation-delay-200">
          Building the infrastructure for intelligent agents
        </p>

        {/* Story paragraphs */}
        <div className="space-y-6 text-base md:text-lg leading-[1.8] text-body text-left opacity-0 animate-fade-in-up animation-delay-300">
          <p>
            <span className="text-foreground font-medium">Vakra</span> derives
            from <span className="text-foreground font-medium">Vakratunda</span>{" "}
            (Sanskrit: वक्रतुण्ड), the first avatar of Lord Ganesha in Hindu
            mythology. Vakratunda, the one with the curved trunk, appeared not
            to destroy, but to transform. When the demon of jealousy
            surrendered, Vakratunda offered forgiveness and a path forward.
          </p>

          <p>
            The curved trunk symbolizes what we believe infrastructure should
            be: <span className="text-foreground font-medium">adaptable</span>{" "}
            enough to navigate any obstacle,{" "}
            <span className="text-foreground font-medium">transformative</span>{" "}
            in turning complexity into simplicity, and built with the{" "}
            <span className="text-foreground font-medium">grace</span> to serve
            those who build upon it.
          </p>

          <p>
            In Hindu tradition, Ganesha is{" "}
            <span className="text-foreground font-medium">Pratham Pujya</span>,
            invoked first before any new beginning. We chose this name because
            we are building that beginning. A complete platform for intelligent
            agents where complexity fades and creation flows.
          </p>

          <p className="text-highlight font-medium">Welcome to Vakra.</p>
        </div>

        {/* Footer */}
        <footer className="mt-16 md:mt-20 pt-8 border-t border-subtle animate-fade-in-up animation-delay-500">
          {/* Sanskrit Verse */}
          <div className="animate-fade-in animation-delay-700">
            <p className="text-xl mb-4 font-serif tracking-wide leading-relaxed">
              वक्रतुण्ड महाकाय सूर्यकोटि समप्रभ · निर्विघ्नं कुरु मे देव
              सर्वकार्येषु सर्वदा
            </p>
            <p className="max-w-2xl mx-auto leading-relaxed">
              &ldquo;O Lord with the curved trunk and mighty body, with the
              brilliance of a million suns, remove all obstacles from my
              endeavors, always.&rdquo;
            </p>
          </div>
        </footer>
      </div>
    </main>
  );
}

export default App;
